import { useState, useEffect, useMemo } from 'react';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';
import { useLocation } from 'react-router-dom';
import SearchSelector from 'legacyfrontend/components/home/components/SearchSelector';
import { useGlobal } from 'legacyfrontend/contexts/GlobalContext';
import HotelsListView from './HotelsListView';

const HotelListPage = () => {
  const { onSearchCount, resetOnSearchCount } = useGlobal();
  const { search } = useLocation();
  const [isMobile, setIsMobile] = useState(false);

  const hasValidSearchParams = useMemo(() => {
    if (!search) return false;

    const searchParams = new URLSearchParams(search);
    const hasDestination = searchParams.get('destinationId') && searchParams.get('destinationName');
    const hasCheckIn = searchParams.get('checkInDate');
    const hasCheckOut = searchParams.get('checkOutDate');

    return hasDestination && hasCheckIn && hasCheckOut;
  }, [search]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(isClient ? window.innerWidth <= 768 : false);
    };
    handleResize();
    isClient && window.addEventListener('resize', handleResize);
    return () => isClient && window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!hasValidSearchParams && onSearchCount > 0) {
      resetOnSearchCount();
    }
  }, [hasValidSearchParams, onSearchCount, resetOnSearchCount]);

  const shouldShowFilters = onSearchCount > 0 || hasValidSearchParams;

  return (
    <>
      <SearchSelector isOnTargetPath />
      {shouldShowFilters && <HotelsListView />}
    </>
  );
};

export default HotelListPage;
